import DefaultPage from '../pages/default.vue';
import DashboardPage from '../pages/dashboard.vue?v=1.4';
 
 
import MonitoringPage from '../pages/monitoring.vue?v=1.4';
import CreditsTransfer from '../pages/credits/credits-transfer.vue?v=1.4';
import CreditsTransferHistory from '../pages/credits/credits-transfer-history.vue?v=1.4';
import AssetInfo from '../pages/asset-info.vue?v=1.4';
import AssetPlayback from '../pages/asset-playback.vue?v=1.4';
 

import NotFoundPage from '../pages/404.vue';

var routes = [

	{
		path: '/default/',
		component: DefaultPage,
		name: 'default'
	},
	{
		path: '/dashboard/',
		alias: '/',
		component: DashboardPage,
		name: 'dashboard'
	},
 
	 
	{
		path: '/credits/',
		//component: CustomersPage,
		name: 'credits',
		routes: [
			{
				path: 'transfer/',
				component: CreditsTransfer,
				name: 'credits-transfer',
			},
			{
				path: 'transfer-history',
				component: CreditsTransferHistory,
				name: 'credits-transfer-history'
			},
			/* {
			   path: 'edit/',
			   component: CustomerEdit,
			   name: 'customer-edit',
			 }*/
		]
	},
 
 
	{
		path: '/monitoring/',
		component: MonitoringPage,
		name: 'monitoring'
	},
	{
		path: '/asset-info/',
		component: AssetInfo,
		name: 'asset-info'
	},
	{
		path: '/asset-playback/:imei/:from/:to/:timeZone',
		component: AssetPlayback,
		name: 'asset-playback'
	},
 



	{
		path: '(.*)',
		component: NotFoundPage,
	},
];

export default routes;
